import { signalKindSchema as runtimeSignalKindSchema, signalSchema as runtimeSignalSchema, } from "@healthos/shared";
import { z } from "zod";
/**
 * Signal schemas.
 *
 * The canonical SignalKind enum is owned by `@healthos/shared` (the
 * runtime/Postgres-era schemas used by Heartbeat, Brief, microsteps,
 * the signal store, agent-context, and every API route). This package
 * re-exports it under PascalCase so `@healthos/schemas` consumers
 * (manifests, outcome strategies, persona activation predicates) get
 * the SAME enum values that live data carries.
 *
 * Why two packages? `@healthos/shared` is the runtime truth; this
 * package historically held richer "design-doc" types that never
 * landed in production. The duplicate enum here drifted (manifests
 * referenced kinds like `sleep.duration` and `medication.adherence`
 * that don't exist in production). Reconciled by making shared
 * canonical and re-exporting; the deeper SignalSchema/SignalValueSchema
 * /SignalBatchSchema/SignalSourceSchema types below are marked legacy
 * - they are dead code we have not yet ripped out.
 */
export const SignalKindSchema = runtimeSignalKindSchema;
export const SignalSchema = runtimeSignalSchema;
// ---------------------------------------------------------------------------
// LEGACY: design-era types kept for now because `d1.ts` still references
// SignalSourceSchema. Nothing else uses these. Delete in a follow-up
// alongside the `d1.ts` rip-out.
// ---------------------------------------------------------------------------
export const SignalSourceSchema = z.enum([
    "apple-health",
    "android-health-connect",
    "fitbit",
    "oura",
    "garmin",
    "dexcom",
    "withings",
    "omron",
    "cgm-generic",
    "ehr-epic",
    "ehr-cerner",
    "calendar-google",
    "calendar-microsoft",
    "self-report",
    "thrive-heartbeat",
    "lexisnexis-human-api",
]);
//# sourceMappingURL=signals.js.map